/**
 * Product Upsell Handlers
 * Global functions for handling product upsell add to cart and variant selection
 */

// Handle variant selection change
window.handleProductUpsellVariantChange = function (selectElement, formId) {
  try {
    const form = document.getElementById(formId);
    if (!form) {
      console.error('Form not found:', formId);
      return;
    }

    const productJsonEl = document.getElementById("ProductJson-" + formId);
    if (!productJsonEl) {
      console.error('JSON not found:', "ProductJson-" + formId);
      return;
    }

    const product = JSON.parse(productJsonEl.textContent);

    if (!product || !product.variants) {
      console.error('Invalid product JSON:', product);
      return;
    }

    const selects = form.querySelectorAll('select[name^="options["]');
    const selectedOptions = Array.from(selects).map(s => s.value);

    const variant = product.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (!variant) return;

    const availabilityEl = form.querySelector('.upsell-availability');
    const switchInput = form.querySelector('.lux-switch input');

    if (availabilityEl) {
      if (!variant.available) {
        availabilityEl.textContent = "Agotado";
      } else {
        availabilityEl.textContent = "";
      }
    }

    // 🔥 DESACTIVAR SWITCH
    if (switchInput) {
      if (!variant.available) {
        switchInput.checked = false;
        switchInput.disabled = true;
        switchInput.setAttribute("aria-disabled", "true");
      } else {
        switchInput.disabled = false;
        switchInput.removeAttribute("aria-disabled");
      }
    }

    // 🔥 actualizar ID
    const input = form.querySelector('.upsell-variant-id');
    if (input) {
      input.value = variant.id;
    }

    // 🔥 actualizar precio
    const priceEl = form.querySelector('.upsell-price');
    if (priceEl && variant.price) {
      if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
        priceEl.textContent = Shopify.formatMoney(
          variant.price,
          window.theme?.moneyFormat || Shopify.money_with_currency_format || Shopify.money_format || "{{ amount_with_currency }}"
        );
      } else {
        priceEl.textContent = formatMoney(variant.price);
      }
    }

  } catch (e) {
    console.error('Upsell variant error:', e);
  }
};

/**
 * Actualiza la UI del carrito (burbujas y Drawer) sin recargar la página
 */
async function updateCartUI() {
  try {
    // 1. Pedimos el HTML actualizado del section cart-drawer
    const response = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');

    // 2. Actualizamos el contenido del Drawer
    const selectors = ['cart-drawer', '#CartDrawer', '.drawer__inner'];
    for (const selector of selectors) {
      const target = document.querySelector(selector);
      const source = html.querySelector(selector);
      if (target && source) {
        target.innerHTML = source.innerHTML;
        break;
      }
    }

    // 3. Actualizar burbujas de conteo (obteniendo el dato fresco)
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.classList.remove('hidden');
    });

    // 4. Asegurarnos que el Drawer sepa que ya no está vacío
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
      // Opcional: Abrirlo automáticamente si quieres feedback inmediato
      // cartDrawer.open(); 
    }
  } catch (e) {
    console.error("Error actualizando UI del carrito:", e);
  }
}

async function handleUpsellSwitchAction(checkbox, formId) {
  const form = document.getElementById(formId);
  if (!form) return;

  const variantInput = form.querySelector('.upsell-variant-id');
  if (!variantInput) return;

  const variantId = variantInput.value;

  // Añadimos un estado visual de carga (opcional)
  checkbox.parentElement.style.opacity = "0.5";
  checkbox.disabled = true;

  try {
    if (checkbox.checked) {
      // AGREGAR
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error();
    } else {
      // ELIMINAR
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [variantId]: 0 } })
      });
      if (!res.ok) throw new Error();
    }

    // Actualización fluida
    await updateCartUI();

  } catch (error) {
    console.error("Error en el switch:", error);
    checkbox.checked = !checkbox.checked; // Revertir si falla
  } finally {
    checkbox.parentElement.style.opacity = "1";
    checkbox.disabled = false;
  }
}

// El handleProductUpsellAdd también debería llamar a updateCartUI() 
// en lugar de tener su propia lógica de inyección para ser consistentes.
window.handleProductUpsellAdd = async function (buttonElement, formId) {
  const form = document.getElementById(formId);
  if (!form) return;

  const variantId = form.querySelector('.upsell-variant-id')?.value;
  if (!variantId) return;

  const originalHTML = buttonElement.innerHTML;
  buttonElement.disabled = true;
  buttonElement.classList.add("is-loading");

  try {
    const response = await fetch('/cart/add.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });

    if (!response.ok) throw new Error();

    buttonElement.innerHTML = "✓ Added!";

    // Llamamos a la misma lógica fluida
    await updateCartUI();

    setTimeout(() => {
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);

  } catch (error) {
    buttonElement.innerHTML = "✗ Error";
    setTimeout(() => {
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  }
};


// Helper function to format money
function formatMoney(cents) {
  if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
    return Shopify.formatMoney(
      cents,
      window.theme?.moneyFormat || Shopify.money_with_currency_format || Shopify.money_format || "{{ amount_with_currency }}"
    );
  }

  return `${(cents / 100).toFixed(2)} €`;
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[id^="upsell-form-"]').forEach(form => {
    const selects = form.querySelectorAll('select[name^="options["]');

    if (selects.length > 0) {
      // Ejecutamos la lógica como si el usuario hubiera cambiado
      window.handleProductUpsellVariantChange(selects[0], form.id);
    }
  });
});

window.updateCheckboxUpsellTotal = function(sourceEl) {
  const wrapper = sourceEl.closest('.draco-upsell-checkbox-wrapper');
  if (!wrapper) return;

  const totalEl = wrapper.querySelector('[data-upsell-checkbox-total]');
  if (!totalEl) return;

  let totalCents = 0;

  wrapper.querySelectorAll('.draco-upsell-checkbox-product').forEach((item) => {
    const checkbox = item.querySelector('.draco-upsell-checkbox-product__switch input');
    if (!checkbox || !checkbox.checked) return;

    const price = parseInt(item.getAttribute('data-upsell-product-price') || '0', 10);
    if (!isNaN(price)) totalCents += price;
  });

  const emptyText = totalEl.getAttribute('data-empty-text') || '';

  if (totalCents <= 0) {
    totalEl.textContent = emptyText;
    return;
  }

  totalEl.textContent = formatMoney(totalCents);
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.draco-upsell-checkbox-wrapper').forEach((wrapper) => {
    const anySwitch = wrapper.querySelector('.draco-upsell-checkbox-product__switch input');
    if (anySwitch) {
      window.updateCheckboxUpsellTotal(anySwitch);
    }
  });
});